/* eslint-disable max-len */
import {
  GROUP_ID_DEVELOPER_HEADQUARTERS,
  GROUP_ID_DEVELOPER_BRANCH_LEADER,
  GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  GROUP_ID_DEVELOPER_EXECUTIVE,
  GROUP_ID_DEVELOPER_SITEPLAN,
  GROUP_ID_DEVELOPER_AGENT_LEADER,
  GROUP_ID_DEVELOPER_AGENCY_ADMIN,
} from './groups';
import { arrayContainsRequired, arrayHasMatchingValues } from '../utils/array';

export const SR_ROLE_ID_DEVELOPER_HEADQUARTERS = 1;
export const SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR = 2;
export const SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = 3;
export const SR_ROLE_ID_DEVELOPER_BRANCH_LEADER = 4;
export const SR_ROLE_ID_DEVELOPER_AGENT_LEADER = 5;
export const SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN = 6;
export const SR_ROLE_ID_STAFF = 7;
export const SR_ROLE_ID_AGENT = 8;
export const SR_ROLE_ID_DEVELOPER_SITEPLAN = 9;

const srRolesMapping = [
  { roleID: SR_ROLE_ID_DEVELOPER_HEADQUARTERS, groupIDs: [GROUP_ID_DEVELOPER_EXECUTIVE, GROUP_ID_DEVELOPER_HEADQUARTERS] },
  { roleID: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR, groupIDs: [GROUP_ID_DEVELOPER_EXECUTIVE, GROUP_ID_DEVELOPER_BRANCH_LEADER, GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR, GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II] },
  { roleID: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II, groupIDs: [GROUP_ID_DEVELOPER_EXECUTIVE, GROUP_ID_DEVELOPER_BRANCH_LEADER, GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II] },
  { roleID: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER, groupIDs: [GROUP_ID_DEVELOPER_EXECUTIVE, GROUP_ID_DEVELOPER_BRANCH_LEADER] },
  { roleID: SR_ROLE_ID_DEVELOPER_AGENT_LEADER, groupIDs: [GROUP_ID_DEVELOPER_EXECUTIVE, GROUP_ID_DEVELOPER_AGENT_LEADER] },
  { roleID: SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN, groupIDs: [GROUP_ID_DEVELOPER_EXECUTIVE, GROUP_ID_DEVELOPER_AGENCY_ADMIN] },
  { roleID: SR_ROLE_ID_STAFF, groupIDs: [GROUP_ID_DEVELOPER_EXECUTIVE] },
  { roleID: SR_ROLE_ID_AGENT, groupIDs: [GROUP_ID_DEVELOPER_EXECUTIVE] },
  { roleID: SR_ROLE_ID_DEVELOPER_SITEPLAN, groupIDs: [GROUP_ID_DEVELOPER_SITEPLAN] },
];

// matchGroupIDToSrRoleID helper function to match group IDs to SR role IDs
export function matchGroupIDToSrRoleID(groupIDs, isAgent) {
  const matchRoles = [];
  srRolesMapping.forEach((srRole) => {
    const hasDERole = (arrayContainsRequired([SR_ROLE_ID_STAFF], matchRoles) || arrayContainsRequired([SR_ROLE_ID_AGENT], matchRoles));
    if (!hasDERole && arrayContainsRequired(srRole.groupIDs, groupIDs)) {
      if (isAgent && srRole.roleID === SR_ROLE_ID_STAFF) {
        matchRoles.push(SR_ROLE_ID_AGENT); // if agent, return agent role ID
      } else {
        matchRoles.push(srRole.roleID);
      }
    }
  });
  return matchRoles;
}

// check if has any required SR role IDs to input SR role IDs
export function hasAnyRequiredRoleIDs(requiredRoleIDs, inputRoleIDs) {
  return arrayHasMatchingValues(requiredRoleIDs, inputRoleIDs);
}

// booking notes
export const defaultBookingNoteAccesses = [
  SR_ROLE_ID_DEVELOPER_HEADQUARTERS,
  SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  SR_ROLE_ID_DEVELOPER_BRANCH_LEADER,
  SR_ROLE_ID_DEVELOPER_AGENT_LEADER,
  SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN,
  SR_ROLE_ID_STAFF,
  SR_ROLE_ID_AGENT,
  SR_ROLE_ID_DEVELOPER_SITEPLAN,
];
export const bookingNoteAccessesOptions = [
  {
    text: 'Headquarters',
    value: SR_ROLE_ID_DEVELOPER_HEADQUARTERS,
    description: 'Admin',
    disabled: true,
  },
  {
    text: 'Supervisor',
    value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
    description: 'BU Leader',
  },
  {
    text: 'Sales Manager',
    value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
    description: 'BU Leader',
  },
  {
    text: 'Sales Admin',
    value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER,
    description: 'BU Leader',
  },
  {
    text: 'Agent Leader',
    value: SR_ROLE_ID_DEVELOPER_AGENT_LEADER,
  },
  {
    text: 'Agency Admin',
    value: SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN,
    description: 'Claim C.',
  },
  {
    text: 'Staff',
    value: SR_ROLE_ID_STAFF,
  },
  {
    text: 'Agent',
    value: SR_ROLE_ID_AGENT,
  },
  {
    text: 'Basic Siteplan',
    value: SR_ROLE_ID_DEVELOPER_SITEPLAN,
  },
];

// reserve delisted units
export const defaultRduAccesses = [
  SR_ROLE_ID_DEVELOPER_HEADQUARTERS,
];
export const rduAccessesOptions = [
  {
    text: 'Headquarters',
    value: SR_ROLE_ID_DEVELOPER_HEADQUARTERS,
    description: 'Admin',
    disabled: true,
  },
  {
    text: 'Supervisor',
    value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
    description: 'BU Leader',
  },
  {
    text: 'Sales Manager',
    value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
    description: 'BU Leader',
  },
  {
    text: 'Sales Admin',
    value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER,
    description: 'BU Leader',
  },
  {
    text: 'Agent Leader',
    value: SR_ROLE_ID_DEVELOPER_AGENT_LEADER,
  },
  {
    text: 'Agency Admin',
    value: SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN,
    description: 'Claim C.',
  },
  {
    text: 'Staff',
    value: SR_ROLE_ID_STAFF,
  },
  {
    text: 'Agent',
    value: SR_ROLE_ID_AGENT,
  },
  {
    text: 'Basic Siteplan',
    value: SR_ROLE_ID_DEVELOPER_SITEPLAN,
  },
];

// payment receipt
export const defaultPaymentReceiptAccesses = [
  SR_ROLE_ID_DEVELOPER_HEADQUARTERS,
  SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  SR_ROLE_ID_DEVELOPER_BRANCH_LEADER,
  SR_ROLE_ID_DEVELOPER_AGENT_LEADER,
  SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN,
  SR_ROLE_ID_STAFF,
  SR_ROLE_ID_AGENT,
  SR_ROLE_ID_DEVELOPER_SITEPLAN,
];
export const paymentReceiptAccessesOptions = [
  {
    text: 'Headquarters',
    value: SR_ROLE_ID_DEVELOPER_HEADQUARTERS,
    description: 'Admin',
    disabled: true,
  },
  {
    text: 'Supervisor',
    value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
    description: 'BU Leader',
  },
  {
    text: 'Sales Manager',
    value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
    description: 'BU Leader',
  },
  {
    text: 'Sales Admin',
    value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER,
    description: 'BU Leader',
  },
  {
    text: 'Agent Leader',
    value: SR_ROLE_ID_DEVELOPER_AGENT_LEADER,
  },
  {
    text: 'Agency Admin',
    value: SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN,
    description: 'Claim C.',
  },
  {
    text: 'Staff',
    value: SR_ROLE_ID_STAFF,
  },
  {
    text: 'Agent',
    value: SR_ROLE_ID_AGENT,
  },
  {
    text: 'Basic Siteplan',
    value: SR_ROLE_ID_DEVELOPER_SITEPLAN,
  },
];

// pre-sales launch: the roles HQ may block from reserving or from the Storey Plan. HQ and Basic
// Siteplan cannot be blocked, matching models.PreSalesLaunchRoleIDs in book-api.
export const preSalesLaunchRoleIDs = [
  SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  SR_ROLE_ID_DEVELOPER_BRANCH_LEADER,
  SR_ROLE_ID_DEVELOPER_AGENT_LEADER,
  SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN,
  SR_ROLE_ID_STAFF,
  SR_ROLE_ID_AGENT,
];
export const preSalesLaunchRoleOptions = bookingNoteAccessesOptions
  .filter(opt => preSalesLaunchRoleIDs.includes(opt.value));

// srRoleIDOfUser returns the user's one exact SR role ID, or 0 for admins and users without one.
// Unlike matchGroupIDToSrRoleID, which returns every role whose groups the user holds (a
// Supervisor also matches Sales Manager and Sales Admin), a Supervisor here is only 2. Mirrors
// utils.SrRoleIDOf in book-api, using the exclusive role flags on the auth state.
export function srRoleIDOfUser(auth) {
  if (!auth || !auth.companyBranch || auth.isSuperAdmin || auth.isAdmin || auth.isAdminBasic) return 0;
  if (auth.isHeadquarters) return SR_ROLE_ID_DEVELOPER_HEADQUARTERS;
  if (auth.companyBranch.isExternal) {
    if (auth.isExternalAgencyAdmin) return SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN;
    if (auth.isExternalAgentLeader) return SR_ROLE_ID_DEVELOPER_AGENT_LEADER;
    if (auth.isExternalAgent) return SR_ROLE_ID_AGENT;
    return 0;
  }
  if (auth.isDeveloperSupervisor) return SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR;
  if (auth.isDeveloperSalesManager) return SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II;
  if (auth.isDeveloperSalesAdmin) return SR_ROLE_ID_DEVELOPER_BRANCH_LEADER;
  if (auth.isDeveloperStaff) return SR_ROLE_ID_STAFF;
  return 0;
}



// WEBPACK FOOTER //
// ./src/constants/srRoleAccess.js